import React from 'react'
import bandMarshChair from '../images/DSC08410 copy.jpg'

import { Link } from 'react-router-dom'
import Slider from '../components/Slider'
import { Helmet } from 'react-helmet-async'

const Press = () => {
  return (
    <>
      <Helmet>
        <title>The Asheville Mountain Boys - Press Kit</title>
        <meta name="description" content="Check out the press kit." />
        <link rel="canonical" href="/press" />
        <link
          rel="icon"
          type="image/png"
          href="/favicon-96x96.png"
          sizes="96x96"
        />
        <link rel="icon" type="image/svg+xml" href="favicon.svg" />
        <link rel="shortcut icon" href="favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="apple-touch-icon.png"
        />
        <link rel="manifest" href="site.webmanifest" />
        <meta charset="utf-8" />
        <link
          rel="icon"
          type="image/png"
          href="favicon.ico/favicon-96x96.png"
          sizes="96x96"
        />
        <link rel="icon" type="image/svg+xml" href="favicon.ico/favicon.svg" />
        <link rel="shortcut icon" href="favicon.ico/favicon.ico" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="favicon.ico/apple-touch-icon.png"
        />
        <meta name="apple-mobile-web-app-title" content="AMB" />
        <link rel="manifest" href="favicon.ico/site.webmanifest" />
      </Helmet>
      <div className="bg-slate-50 pt-20 md:pt-0">
        <header className="h-[35vh] overflow-hidden">
          <div className="relative h-full">
            <img
              src={bandMarshChair}
              alt="Jackson holding guitar"
              className="w-full h-[35vh] md:h-[60vh] object-cover object-[50%_10%] opacity-50"
            />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <h1 className="text-gray-800 text-2xl md:text-3xl tracking-widest">
                Press Kit
              </h1>
            </div>
          </div>
        </header>

        <div className="border rounded-lg shadow-xl p-6 max-w-3xl mx-auto mt-6 mb-5    bg-slate-100 custom-container">
          <Slider />
        </div>
        <div className="text-center p-4">
          <Link
            target="_blank"
            to="https://drive.google.com/drive/folders/1GPWP2ALHZVF9nzEVjSrU81tWcpxu_zjr?usp=drive_link"
          >
            <button className="rounded bg-cyan-600 text-gray-100 font-bold  py-2 px-4 tracking-widest  hover:opacity-80 duration-500 shadow-xl mr-6 ">
              DOWNLOAD HI-RES PHOTOS
            </button>
          </Link>
          <Link
            target="_blank"
            to="https://drive.google.com/drive/folders/1GPWP2ALHZVF9nzEVjSrU81tWcpxu_zjr?usp=drive_link"
          >
            <button className="rounded bg-slate-200 text-cyan-600 font-bold mr-4 py-2 px-4 tracking-widest hover:opacity-70 duration-500 mb-6 shadow-xl mt-3 ">
              DOWNLOAD STAGE PLOT
            </button>
          </Link>
        </div>

        <div className="flex  justify-center p-6 -mt-5">
          <p className="max-w-3xl">
            By their name, you know where they are from, and by their sound, you
            know what they are about. The Asheville Mountain Boys are on a
            mission to capture not just the style but the spirit of traditional
            bluegrass. Asheville, NC has long been known for great music and its
            roots in bluegrass go back to the founding of the genre (Bill
            Monroe’s first broadcast performance as the Bluegrass Boys was at
            Asheville radio station WWNC in 1938) A group that firmly stakes its
            claim to the tradition of the music from the area, The Asheville
            Mountain Boys spring onto the scene with a thought, ”What happened
            to bluegrass?” It’s not a disparaging one that condemns current
            styles in the genre but rather asks, “Why do we love this music in
            the first place” and answers with an approach that is true to the
            originators of the genre in the sense of both style and philosophy.
            Bluegrass is raw emotion, excitement, drive, and authenticity. It is
            not sanitized or compromised but a reflection of the lives of those
            who play it. It’s storytelling that follows a throughline of
            tradition.
          </p>
        </div>
        <div className="text-center p-4">
          {/* <Link to="https://ashevillemountainboys.bandcamp.com/track/another-day">
            <button className="rounded bg-slate-50 text-yellow-600 font-bold  py-2 px-4 tracking-widest  hover:opacity-80 duration-500 shadow-xl mr-6 ">
              STREAM <span className="font-normal">//</span> PURCHASE
            </button>
          </Link> */}
          <Link to="/contact">
            <button className="rounded  bg-cyan-600 text-gray-100  font-bold mr-4 py-2 px-4 tracking-widest hover:opacity-70 duration-500 mb-6 shadow-xl mt-3 ">
              CONTACT
            </button>
          </Link>
        </div>
      </div>
    </>
  )
}

export default Press
